import React from 'react';
import { Layout } from '../common/Layout';
import { AdminPanelShell } from './AdminPanelShell';

export const AdminLayout: React.FC = () => {
  return (
    <Layout variant="admin" hideSidebar title="Ingenium Admin Panel">
      <AdminPanelShell />
    </Layout>
  );
};
